<template>
  <div>
           <vue-headful
            title="Forgot Password - Girish Jewellers"
            description="Forgot Password, girish jewellers is the jewellery shop having varity of golden and silver ornament designs of products like bangles, bracelets, golden sets,pandent set, rings, wedding bands in rajkot gujarat india."
            keywords= "golden ornaments, silver ornaments, bangles, bracelets, golden sets,pandent set, rings, wedding bands, online order,best, purity, jewellery shop, in rajkot gujarat india"
            abstract = "Golden and silver ornaments online orering and selling shop"
            author = "Girish Jewellers"
            copyright = "Girish Jewellers"
            robots = "INDEX,FOLLOW"
        />    
    <LeftPanel msg="Welcome to Your Vue.js App"/>
    <div>
      <div class="page-box">
        <div class="page-box-content">
          <div id="header-area">          
          <TopHeader msg="Welcome to Your Vue.js App"/>
          <Header msg="Welcome to Your Vue.js App"/>
          </div>
            <section id="main">
                <div class="container"> 
                    <article class="content span9">
                <ul id="checkoutsteps" class="clearfix ">
                    <li class="active">
                    
                    <div class="step-content">
                        <div class="col-set clearfix">
                        <div class="">
                            <h3 class="title">Recover Your Password.</h3>
                            <label>Email: <span class="required">*</span></label>
                            <div :class="{ 'invalid': $v.results.Profile.email.$error }">
                            <input class="input-block-level" id="email" name="email" type="email" placeholder="Email Address" maxlength="150" v-model.trim="$v.results.Profile.email.$model">	
                            </div>
                            <span class="invalid-mesage" v-if="$v.results.Profile.email.$dirty && !$v.results.Profile.email.required">
                              Email address is required
                            </span>                            
                            <span class="invalid-mesage" v-if="$v.results.Profile.email.$invalid && results.Profile.email != ''">
                               Invalid email address
                            </span>                            
                            
                            <div class="clearfix"></div>
                            <div class="buttons-box clearfix">
                              <button  type="button"  class="btn" v-on:click="submit" id="btnsubmit" name="btnsubmit">Submit</button>
                              <button  type="button"  class="btn" v-on:click="$router.push('/login')" id="btncancel" name="btncancel">Cancel</button>
                            <span class="required"><b>*</b> Required Field</span>
                            </div><!-- .buttons-box -->                                
                        </div>
                        </div>
                    </div>
                    </li>
                    </ul>
                    </article>
                    <br><br><br><br>
                </div>
            </section>         
        <Footer msg="Welcome to Your Vue.js App" v-if="isMobile()"/>
        
        </div><!-- .page-box-content -->
        </div><!-- .page-box -->
     </div>
      <FooterWeb msg="Welcome to Your Vue.js App" v-if="!isMobile()"/>
    </div>
</template>

<script>
// @ is an alias to /src
import Vue from 'vue'
import $ from 'jquery'
import LeftPanel from '@/components/LeftPanel.vue'
import TopHeader from '@/components/TopHeader.vue'
import Header from '@/components/Header.vue'
import Footer from '@/components/Footer.vue'
import FooterWeb from '@/components/FooterWeb.vue'
import Common from '@/common.js'
import { required, email} from 'vuelidate/lib/validators'
import Vuelidate from 'vuelidate';
import vueHeadful from 'vue-headful';

Vue.use(Vuelidate)

export default {
  name: 'ForgotPassword',
  components: {
    vueHeadful,
    LeftPanel,
    TopHeader,
    Header,
    Footer,
    FooterWeb
    },
  watch:{
},
beforeMount :function(){
      $("#email").focus();
      //Common.preparValidator(this.$v,'results');
    },
    mounted:function(){
      this.loadOnMount();
    },
    data:function(){
        return {results: { Profile:{email:""}} };
    },
    validations: {
      results: {Profile:{
          email: {
            required,
            email
          },
      }
      } 
    },    
    methods:{
          isMobile:function(){
   return Common.isMobile();
   },
    get_submit_response:function(response)
    { 
    
        var rdata = JSON.parse(response);
        //this.results.Profile = rdata;
  
        if(rdata.password_send_status == '1')
        {
          Common.showSuccess("Your password has been sent to your registered email address successfully.");
          this.$router.push("/login");
        }

    },submit: function()
    {
        //this.errors.push("Name required.");
        //alert(this.results.$touch());

        this.$v.results.Profile.$touch();
        //alert(JSON.stringify(this.$v.results.password));

        if (this.$v.results.Profile.$pending || this.$v.results.Profile.$error) 
        {

          Common.showError("Invalid input, Please check the entered values again.");
          // 1. Loop the keys
            for (let key in Object.keys(this.$v.results.Profile)) {
              // 2. Extract the input
              const input = Object.keys(this.$v.results.Profile)[key];
              // 3. Remove special properties
              if (input.includes("$")) return false;
              // 4. Check for errors

              if (this.$v.results.Profile[input].$error) {
                // 5. Focus the input with the error
                $("#" + input).focus();

                // 6. Break out of the loop
                break;
              }

            }

          return;
        }
      // to form submit after this
      
      Common.callServerFunction("Users/UserController::ForgotPassword",this.get_submit_response,this.results.Profile,"Users");
      
    //Common.showValidation(["Name required.","Address required.","Surname required."]);        
      },onResize: function() {
    },
      loadOnMount: function() {
        $.get('js/main.js', function(data) {
        eval(data);
   //process text file line by line
   //$('#div').html(data.replace('n',''));
        });
    }

  }
    
}
</script>